<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <b-row align-v="center">
                <b-col>
                    <legend>Relayed Deposits</legend>
                    <small class="text-muted">Deposits raised and approved automatically from relayed bank SMS</small>
                </b-col>
                <b-col cols="auto" class="d-flex align-items-center">
                    <b-button type="button" @click="getDeposits" pill variant="outline-dark">
                        Refresh
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-table striped hover responsive :items="items" :fields="fields" small>
                        <template #cell(agentCode)="data">
                            <span v-if="data.item.agentCode">{{ data.item.agentCode }}</span>
                            <span v-else class="text-muted">&mdash;</span>
                        </template>
                        <template #cell(deposit)="data">
                            <b-badge variant="secondary">{{ data.item.bank }}</b-badge>
                            <b-badge variant="light">{{ data.item.depositType }}</b-badge>
                            <div class="font-weight-bold">R{{ data.item.amount.toFixed(2) }}</div>
                        </template>
                        <template #cell(receivedAt)="data">
                            {{ data.item.receivedAt | formateDate }}
                        </template>
                        <template #cell(depositApprovedOn)="data">
                            <b-badge variant="success">{{ data.item.depositApprovedOn | formateDate }}</b-badge>
                        </template>
                    </b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                    <span>Total records : {{ totalRecords }}</span>
                    <span class="ml-4 font-weight-bold">Total deposited : R{{ totalAmount.toFixed(2) }}</span>
                </b-col>
            </b-row>

            <loading :active.sync="isLoading" :is-full-page="true"></loading>
        </div>
    </main>
</div>
